import Axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { logout, toast } from '../../func';
import { UserAuth } from '../types/models';

export const fetch = async <T>(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  body?: { [key: string]: any } | FormData,
  options?: {
    responseType?: 'json' | 'text' | 'blob' | 'arraybuffer' | 'stream';
    signal?: AbortSignal;
    errorHandler?: (error: AxiosError) => void;
  }
): Promise<T | null> => {
  try {
    const item = localStorage.getItem('auth_data');
    const authData =
      item && !(body instanceof FormData) ? JSON.parse(item) : {};
    const headers = item && body instanceof FormData ? JSON.parse(item) : {};
    const combinedBody =
      body instanceof FormData ? body : { ...authData, ...body };

    const requestConfig: AxiosRequestConfig = {
      url,
      method,
      headers,
      params: ['GET', 'DELETE'].includes(method) ? combinedBody : null,
      data: ['PUT', 'POST'].includes(method) ? combinedBody : null,
      signal: options?.signal,
      responseType: options?.responseType,
    };
    const response: AxiosResponse = await Axios.request(requestConfig);
    if (response.data?.type === 'GLOBAL_TOAST') toast(response.data);

    return response.data as T;
  } catch (error) {
    const err = error as AxiosError<T>;

    if (options?.errorHandler) {
      options.errorHandler(err);
      return null;
    }

    if (err?.response && options?.responseType === 'arraybuffer') {
      const { data } = err.response;
      const decoder = new TextDecoder();
      const text = decoder.decode(data as Buffer);

      try {
        const json = JSON.parse(text);
        logout({ response: { data: json } });
      } catch (err) {
        toast(text);
      }
      return null;
    }
    logout(err);
    return null;
  }
};

export const getAuthData = (): UserAuth | null => {
  const localData: string | null = localStorage.getItem('auth_data');
  if (localData !== null) {
    return JSON.parse(localData) as UserAuth;
  } else {
    return null;
  }
};
